export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
        },
        bodyClass: {
            type: String,
            default: 'mx-2',
        }
    },
};